import _ from 'underscore';
import { getTheme } from '@fluentui/react';
import { mergeStyles, mergeStyleSets } from '@fluentui/react/lib/Styling';

const { palette } = getTheme();

export const iconNames = {
  met: 'CompletedSolid',
  'half-met': 'AlertSolid',
  'not-met': 'RadioBtnOff',
};

export const iconNamesUINext = {
  met: 'CompletedSolid',
  'half-met': 'CRMCustomerInsightsApp',
  'not-met': 'CRMCustomerInsightsApp',
};

const iconClass = mergeStyles({
  fontSize: 16,
  marginRight: 6,
  verticalAlign: 'text-top',
});

export const iconClasses = mergeStyleSets({
  met: [{ color: '#107C10' }, iconClass],
  'half-met': [{ color: '#FFB900' }, iconClass],
  'not-met': [{ color: palette.neutralSecondary }, iconClass],
});

export const iconClassesUINext = mergeStyleSets({
  met: [{ color: '#107C10' }, iconClass],
  'half-met': [{ color: '#0078D4' }, iconClass],
  'not-met': [{ color: '#0078D4' }, iconClass],
});

export const styles = {
  root: {
    borderRadius: 2,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.108), 0px 1.6px 3.6px rgba(0, 0, 0, 0.132)',
    margin: '2px 0 32px 0',
    padding: '15px 20px',
    position: 'relative',

    selectors: {
      '& ul.ad-strength-actions': {
        listStyleType: 'none',
        paddingInlineStart: 0,
      },

      '& ul.ad-strength-actions li': {
        padding: '2px 0',
        lineHeight: '20px',
      },

      '& .ad-strength-content': {
        display: 'inline-flex',
        marginTop: 15,
      },

      '& .ad-strength-score': {
        marginRight: 16,
        textAlign: 'center',
      },

      '& .ad-strength-score-vnext': {
        marginTop: -10,
        marginLeft: -20,
      },

      '& .ad-strength-suggestions': {
        fontSize: 14,
        lineHeight: '20px',
      },

      '& .ad-strength-suggestions-detail': {
        display: 'block !important',
      },
      '& .ad-strength-suggestion-detail-tips-item-container': {
        display: 'block !important',
      },
    },
  },
};

export const getNewAdStrengthStyles = () => ({
  container: {
    '& .ad-strength-title': {
      fontWeight: 600,
      '& .icon': {
        fontSize: 10,
        marginRight: 4,
        height: 20,
        width: 20,
        lineHeight: '20px',
        fontWeight: 600,
        textAlign: 'center',
        borderRadius: '50%',
      },
      '& .Incomplete': {
        color: '#BC0505',
        background: '#FDE7E9',
      },
      '& .Poor': {
        color: '#BC0505',
        background: '#FDE7E9',
      },
      '& .Average': {
        color: '#D83B01',
        background: '#FFF4CE',
      },
      '& .Good': {
        color: '#107C10',
        background: '#DFF6DD',
      },
      '& .Excellent': {
        color: '#107C10',
        background: '#DFF6DD',
      },
    },
    '& .ad-strength-score-vnext': {
      marginTop: 8,
    },
    '& ul.ad-strength-actions': {
      listStyleType: 'none',
      paddingInlineStart: 0,
    },
    '& ul.ad-strength-actions li': {
      padding: '2px 0',
      lineHeight: '20px',
      '& .suggestion-icon': {
        fontSize: 16,
        marginRight: 6,
        verticalAlign: 'text-top',
        color: '#0078D4',
      },
    },
    '& .ad-strength-suggestions': {
      marginTop: 16,
    },
  },
  cardTitle: {
    fontSize: '18px',
    display: 'inline',
  },
});

export const getAdStrengthTopGridStyles = () => ({
  container: _.extend({
    margin: '16px 16px 16px 32px',
    padding: '22px 16px 16px 32px',
    width: 'fit-content',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    borderRadius: '2px',
    '& .ad-strengh-panel-title': {
      fontSize: '18px',
      fontWeight: 900,
      paddingBottom: '16px',
    },
  }, getNewAdStrengthStyles().container),
});

export const getPickerListStyles = () => ({
  root: {
    boxShadow: '0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.132), 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.108)',
    backgroundColor: '#fff',
    minWidth: '180px',
    '&>li>a': {
      color: palette.neutralPrimary,
      height: '36px',
      lineHeight: '36px',
      padding: '0 8px',
      whiteSpace: 'nowrap',
      display: 'block',

      '&:hover': {
        backgroundColor: palette.neutralLighter,
        color: '#201f1e',
      },

      '&:focus': {
        backgroundColor: 'transparent',
        color: palette.neutralPrimary,
        position: 'relative',
        textDecoration: 'none',
        outline: `1px solid ${palette.neutralSecondary}`,
      },
    },
  },
  pickerTitle: {
    padding: '10px 10px 3px 10px',
    fontWeight: 'bold',
  },
});

export const getLLMPickerListStyles = () => ({
  root: {
    backgroundColor: '#fff',
    minWidth: '350px',
    position: 'relative',
    paddingLeft: 0,
    margin: 0,
    listStyle: 'none',
    '&>li>a': {
      color: palette.neutralPrimary,
      height: '36px',
      lineHeight: '36px',
      padding: '0 8px',
      paddingLeft: 32,
      whiteSpace: 'nowrap',
      display: 'block',

      '&:hover': {
        backgroundColor: palette.neutralLighter,
        color: '#201f1e',
      },

      '&:focus': {
        backgroundColor: 'transparent',
        color: palette.neutralPrimary,
        position: 'relative',
        textDecoration: 'none',
        border: `1px solid ${palette.neutralSecondary}`,
      },
    },
  },
  pickerTitle: {
    borderTop: '1px solid #f3f2f1',
    color: '#323130',
    padding: '10px 10px 3px 32px',
    fontWeight: 'bold',
  },
});

export const shimmerWrapperClass = mergeStyles({
  padding: 2,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
    },
  },
});

export const llmIconClass = mergeStyles({
  position: 'absolute',
  top: 18,
  left: 24,
});
